/**
 * Годы барабана BirthPicker (ПР8 архива 1С, спецификация 22.1): первый год и год, на котором барабан открывается.
 *  • первый год — fromYear (по умолчанию 90 лет назад, как раньше), но не позже текущего;
 *  • вниз барабан расширяется ТОЛЬКО при заданном fromYear (дата найма в HR): сохранённая дата раньше fromYear не
 *    поднимается до него — иначе простое «ОК» записало бы другой год (раньше так дата найма 2019 превращалась в 2020);
 *    вниз — не дальше YEAR_FLOOR: мусорная дата («0001-01-01») не строит барабан на тысячи строк;
 *  • без fromYear (дни рождения игроков из оцифровки и бота) — как раньше: барабан 90 лет, год значения не трогаем;
 *  • пустое значение — 2000-й, при fromYear — не раньше первого года.
 */
export interface BirthYears { y0: number; y: number }

/** Нижний край барабана при расширении вниз. */
export const YEAR_FLOOR = 1900;

export function birthYears(value: string | undefined, fromYear: number | undefined, nowY: number): BirthYears {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || "");
  const own = m ? +m[1]! : null;
  if (fromYear == null) return { y0: Math.min(nowY - 90, nowY), y: own ?? 2000 };
  const y0 = Math.min(fromYear, Math.max(own ?? fromYear, YEAR_FLOOR), nowY);
  return { y0, y: Math.max(own ?? 2000, y0) };
}
